import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Box, Typography, Button, Chip, Alert, CircularProgress } from '@mui/material';
import SendRoundedIcon from '@mui/icons-material/SendRounded';
import { Page, Card } from '../ui';

export default function NotificationsPage() {
  const [info, setInfo] = useState({ configured: false, connected: false, connect_link: null });
  const [msg, setMsg] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => { axios.get('/settings/telegram').then((r) => setInfo(r.data)).catch(() => {}); }, []);
  useEffect(() => { load(); }, [load]);

  const check = async () => {
    setBusy(true); setMsg(null);
    try { await axios.post('/settings/telegram/check'); setMsg({ t: 'success', x: 'Telegram подключён!' }); load(); }
    catch (e) { setMsg({ t: 'error', x: (e.response && e.response.data && e.response.data.detail) || 'Не удалось' }); }
    setBusy(false);
  };
  const test = async () => {
    setBusy(true); setMsg(null);
    try { await axios.post('/settings/telegram/test'); setMsg({ t: 'success', x: 'Тестовое сообщение отправлено' }); }
    catch (e) { setMsg({ t: 'error', x: (e.response && e.response.data && e.response.data.detail) || 'Не удалось' }); }
    setBusy(false);
  };

  return (
    <Page title="Настройка уведомлений" subtitle="Telegram для алертов о статусах кабинетов, модерации и правил">
      <Card sx={{ p: 3, maxWidth: 640 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <SendRoundedIcon sx={{ color: 'info.main' }} />
          <Typography sx={{ fontSize: 16, fontWeight: 700, color: 'text.primary' }}>Telegram</Typography>
          <Chip size="small" label={info.connected ? 'Подключён' : 'Не подключён'}
            color={info.connected ? 'success' : 'default'} variant="outlined" sx={{ fontWeight: 600 }} />
        </Box>
        {!info.configured ? (
          <Typography sx={{ fontSize: 13, color: 'text.secondary' }}>
            Бот не настроен на сервере (нужны переменные TELEGRAM_BOT_TOKEN и TELEGRAM_BOT_USERNAME).
          </Typography>
        ) : (
          <>
            <Typography sx={{ fontSize: 12.5, color: 'text.secondary', mb: 2 }}>
              Нажми «Подключить» — откроется бот в Telegram, там нажми <b>Start</b>. Затем вернись и нажми «Я нажал Start».
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5, flexWrap: 'wrap', alignItems: 'center' }}>
              <Button variant="contained" disabled={!info.connect_link} onClick={() => window.open(info.connect_link, '_blank')}>
                Подключить Telegram
              </Button>
              <Button variant="outlined" disabled={busy} onClick={check}>Я нажал Start</Button>
              <Button variant="outlined" disabled={busy || !info.connected} onClick={test}>Тест</Button>
              {busy && <CircularProgress size={18} />}
            </Box>
          </>
        )}
        {msg && <Alert severity={msg.t} sx={{ mt: 2, borderRadius: '6px' }}>{msg.x}</Alert>}
      </Card>
    </Page>
  );
}
